/**
 * @author xiaohuangmaoth
 * @description 组织路径完成率
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';
import { mapStateToProps, handleExport } from '../../utils';

const { WizContainer, WizReduxTemplate } = framework_tool;

class OrgPathCompletion extends WizContainer {
  componentName = "OrgPathCompletion";

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: handleExport.bind(this, { title: '组织路径完成率', column })
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(mapStateToProps.bind(this, { nameSpace: 'pathReport', method: 'getPageListOrg' }))(OrgPathCompletion);
